import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";

const speechKey = process.env.REACT_APP_AZURE_SPEECH_KEY;
const serviceRegion = process.env.REACT_APP_AZURE_SPEECH_REGION;

let synthesizer = null;
let isSpeaking = false;
let audioElement = null;
let recognizer = null;

export const getIsSpeaking = () => isSpeaking;
//original

// export const startSpeech = async (
//   text,
//   onStart = () => {},
//   onStop = () => {}
// ) => {
//   // Stop any ongoing speech before starting a new one
//   stopSpeech();

//   if (!speechKey || !serviceRegion) {
//     console.error("Azure Speech key or region is missing.");
//     onStop();
//     return;
//   }

//   const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
//     speechKey,
//     serviceRegion
//   );
//   speechConfig.speechSynthesisVoiceName = "en-US-GuyNeural";

//   const stream = SpeechSDK.AudioOutputStream.createPullStream();
//   const audioConfig = SpeechSDK.AudioConfig.fromStreamOutput(stream);

//   synthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig, audioConfig);

//   isSpeaking = true;
//   onStart();

//   synthesizer.speakTextAsync(
//     text,
//     (result) => {
//       const blob = new Blob([result.audioData], { type: "audio/wav" });
//       const url = URL.createObjectURL(blob);

//       audioElement = new Audio(url);
//       audioElement.play();

//       audioElement.onended = () => {
//         isSpeaking = false;
//         onStop();
//       };
//     },
//     (error) => {
//       console.error("Speech synthesis failed:", error);
//       isSpeaking = false;
//       onStop();
//     }
//   );
// };

export const startSpeech = async (
  text,
  onStart = () => {},
  onStop = () => {}
) => {
  // Stop any ongoing speech
  stopSpeech();

  if (!speechKey || !serviceRegion) {
    console.error("Azure Speech key or region is missing.");
    onStop();
    return;
  }

  const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
    speechKey,
    serviceRegion
  );

  speechConfig.setProperty(
    SpeechSDK.PropertyId.SpeechServiceConnection_SynthOutputFormat,
    SpeechSDK.SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3
  );

  speechConfig.speechSynthesisVoiceName = "en-AU-TimNeural";
  // speechConfig.speechSynthesisVoiceName = "en-AU-WilliamNeural";
    // speechConfig.speechSynthesisVoiceName = "en-AU-DarrenNeural";
      // speechConfig.speechSynthesisVoiceName = "en-AU-DuncanNeural";
        // speechConfig.speechSynthesisVoiceName = "en-AU-KenNeural";
          // speechConfig.speechSynthesisVoiceName = "en-AU-NeilNeural";

  const stream = SpeechSDK.AudioOutputStream.createPullStream();
  const audioConfig = SpeechSDK.AudioConfig.fromStreamOutput(stream);

  synthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig, audioConfig);

  isSpeaking = true;

  synthesizer.speakTextAsync(
    text,
    (result) => {
      const blob = new Blob([result.audioData], { type: "audio/mpeg" });
      const url = URL.createObjectURL(blob);

      audioElement = new Audio(url);

      audioElement.onplaying = () => {
        onStart(); // Only call onStart when playback actually begins
      };

      audioElement.onended = () => {
        isSpeaking = false;
        onStop();
      };

      audioElement.onerror = (e) => {
        console.error("Audio playback error:", e);
        isSpeaking = false;
        onStop();
      };

      audioElement.play().catch((err) => {
        console.error("Audio play() failed:", err);
        isSpeaking = false;
        onStop();
      });
    },
    (error) => {
      console.error("Speech synthesis failed:", error);
      isSpeaking = false;
      onStop();
    }
  );
};

export const stopSpeech = () => {
  if (audioElement) {
    audioElement.pause();
    audioElement.currentTime = 0;
    audioElement = null;
  }

  if (synthesizer) {
    try {
      synthesizer.close();
    } catch (e) {
      console.warn("Error closing synthesizer:", e);
    } finally {
      synthesizer = null;
    }
  }

  isSpeaking = false;
};

//original
// export const recognizeSpeech = async () => {
//   return new Promise((resolve, reject) => {
//     if (!speechKey || !serviceRegion) {
//       reject("Speech service key or region is missing.");
//       return;
//     }

//     const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
//       speechKey,
//       serviceRegion
//     );
//     const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
//     const recognizer = new SpeechSDK.SpeechRecognizer(
//       speechConfig,
//       audioConfig
//     );

//     recognizer.recognizeOnceAsync(
//       (result) => {
//         if (result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
//           resolve(result.text);
//         } else {
//           reject("Speech not recognized.");
//         }
//         recognizer.close();
//       },
//       (err) => {
//         reject(err);
//         recognizer.close();
//       }
//     );
//   });
// };

// export const recognizeSpeech = ({
//   onRecognizing,
//   onRecognized,
//   onError,
//   onStop,
//   action = "start",
// }) => {
//   if (!speechKey || !serviceRegion) {
//     onError && onError("Speech service key or region is missing.");
//     return;
//   }

//   if (action === "stop") {
//     if (recognizer) {
//       recognizer.stopContinuousRecognitionAsync(() => {
//         recognizer.close();
//         recognizer = null;
//         onStop && onStop();
//       });
//     }
//     return;
//   }

//   // action === "start"
//   const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
//     speechKey,
//     serviceRegion
//   );
//   const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
//   recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);

//   recognizer.recognizing = (s, e) => {
//     onRecognizing && onRecognizing(e.result.text);
//   };

//   recognizer.recognized = (s, e) => {
//     if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
//       onRecognized && onRecognized(e.result.text);
//     }
//   };

//   recognizer.canceled = (s, e) => {
//     console.error("Recognition canceled:", e.errorDetails);
//     onError && onError(e.errorDetails);
//     recognizeSpeech({ action: "stop", onStop }); // stop on cancel
//   };

//   recognizer.sessionStopped = (s, e) => {
//     recognizeSpeech({ action: "stop", onStop });
//   };

//   recognizer.startContinuousRecognitionAsync();
// };

// export const stopContinuousRecognition = () => {
//   if (recognizer) {
//     recognizer.stopContinuousRecognitionAsync(() => {
//       recognizer.close();
//       recognizer = null;
//     });
//   }
// };

export const seekBackward = () => {
  if (audioElement) {
    audioElement.currentTime = Math.max(0, audioElement.currentTime - 10);
  }
};

export const seekForward = () => {
  if (audioElement) {
    audioElement.currentTime = Math.min(
      audioElement.duration,
      audioElement.currentTime + 10
    );
  }
};

let silenceTimeout = null;
// make sure it's tracked globally

const resetSilenceTimeout = ({ onStop }) => {
  if (silenceTimeout) clearTimeout(silenceTimeout);
  silenceTimeout = setTimeout(() => {
    console.log("Auto-stopping due to silence...");
    recognizeSpeech({ action: "stop", onStop });
  }, 3000); // 3s silence timeout
};

export const recognizeSpeech = ({
  onRecognizing,
  onRecognized,
  onError,
  onStop,
  action = "start",
}) => {
  if (!speechKey || !serviceRegion) {
    onError && onError("Speech service key or region is missing.");
    return;
  }

  if (action === "stop") {
    if (recognizer) {
      recognizer.stopContinuousRecognitionAsync(() => {
        recognizer.close();
        recognizer = null; // 🔑 clear old recognizer
        if (silenceTimeout) clearTimeout(silenceTimeout);
        onStop && onStop();
      });
    }
    return;
  }

  // 🔑 Always create a new recognizer on "start"
  const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
    speechKey,
    serviceRegion
  );
  const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
  recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);

  recognizer.recognizing = (s, e) => {
    onRecognizing && onRecognizing(e.result.text);
    resetSilenceTimeout({ onStop });
  };

  recognizer.recognized = (s, e) => {
    if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
      onRecognized && onRecognized(e.result.text);
      resetSilenceTimeout({ onStop });
    }
  };

  recognizer.canceled = (s, e) => {
    console.error("Recognition canceled:", e.errorDetails);
    onError && onError(e.errorDetails);
    recognizeSpeech({ action: "stop", onStop });
  };

  recognizer.sessionStopped = (s, e) => {
    recognizeSpeech({ action: "stop", onStop });
  };

  recognizer.startContinuousRecognitionAsync();
  resetSilenceTimeout({ onStop });
};
